<ngx-spinner></ngx-spinner>
<section class="container-table">
  <div class="header-search-table d-flex align-items-end justify-content-between mb-4 pb-2">
    <div class="d-flex align-items-center">
      <!-- <mat-form-field appearance="outline">
        <mat-label class="">
          <mat-icon class="rotate-icon"> sync_alt</mat-icon>
          <span>Sort by</span>
        </mat-label>
        <mat-select [(ngModel)]="selectedValue" name="sort">
          <mat-option *ngFor="let sort of sorts" [value]="sort.value">
            {{sort.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
      <div class="srch_wrpr">
        <input type="checkbox" name="" class="checkbox">
        <div class="srch_sb_cnt">
          <input type="search" name="text_bar" id="" class="sech_txt_inpt" placeholder="Type to search..."
            (keyup)="applyFilter($event.target.value)" #input>
          <button class="srch_btn">
            <mat-icon>search</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- <div class="last-update text-end d-none">
      Last Update: 15/08/2021
    </div> -->

  </div>
  <!-- Table -->

  <!-- <mat-form-field appearance="standard">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
  </mat-form-field> -->

  <div class="">
    <table class="w-100" mat-table [dataSource]="dataSource" matSort>

      <!-- PageName Column -->
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef> PAGE NAME </th>
        <td mat-cell *matCellDef="let element"> {{element.title}} </td>
      </ng-container>

      <!-- LAST UPDATED Column -->
      <ng-container matColumnDef="lastUpdated">
        <th mat-header-cell *matHeaderCellDef> LAST UPDATED </th>
        <td mat-cell *matCellDef="let element" class="text-center"> {{element.updated_at | date}} </td>
      </ng-container>



      <!-- PAGE VISIBILITY Column -->
      <!-- <ng-container matColumnDef="pageVisibility">
        <th mat-header-cell *matHeaderCellDef> PAGE VISIBILITY </th>
        <td mat-cell *matCellDef="let element; index as i">
          <fieldset class="input-toggle">
            <label class="input-toggle-label d-inline-block" for="switch{{i}}">
              <input type="checkbox" id="switch{{i}}" value="{{element.is_visible}}"
                (change)="checkBoxvalue($event.target.checked, element.id )" [checked]="element.is_visible == 1">
              <span class="switch"></span>
            </label>
          </fieldset>

        </td>
      </ng-container> -->

      <!-- Edit Page Column -->
      <ng-container matColumnDef="editPage">
        <th mat-header-cell *matHeaderCellDef class="text-center">ACTIONS </th>
        <td mat-cell *matCellDef="let element;let i=index;" class="action-link ">
          <button class="btn_secondary  me-3" *ngIf="element.page_id!=0" [routerLink]="['/page-manager/page/',element.id]">
            Edit Page
          </button>
            <button class="btn_secondary" *ngIf="element.page_id==0" [routerLink]="['/content-manager/',element.id]">
            <!-- <span class="spinner-border spinner-bor/0der-sm" role="status" aria-hidden="true"></span> -->
            Edit Page
          </button>
           <a  class="" [href]="websiteUrl+pageLinks[i]" target="_blank">
            <mat-icon > visibility_icon</mat-icon>
        </a>

        </td>
      </ng-container>



      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
      </tr>
    </table>

   </div>




</section>
